export default "__VITE_ASSET__C9KBnek0__"